import React from 'react';
import {
  VehicleAlertWrapper,
  PaidOffWrapper,
  OverdueWrapper,
  CommonStyles,
} from './VehicleAlert.styles';
import { MANAGEABLE_LOAN_STATE, PAID_OFF_LOAN_STATE } from '../../../constants';
import FailedIcon from '../../../assets/FailedIcon';
import SuccessIcon from '../../../assets/SuccessIcon';
import { DateMasks, formatDate } from '../../../utils/dateUtils';

const VehicleAlert = ({ loanDetails }: any) => {
  if (!loanDetails) {
    return null;
  }

  const { loanState, nextPaymentDate, isPaymentPastDue } = loanDetails;

  let currentAlert: any = null;

  const iconStyle = {
    margin: '0 10px 0 0',
    verticalAlign: 'middle',
  };

  switch (loanState) {
    case PAID_OFF_LOAN_STATE:
      currentAlert = (
        <PaidOffWrapper>
          <CommonStyles>
            <SuccessIcon style={iconStyle} />
            <span>Congratulations, your loan has been paid off!</span>
          </CommonStyles>
        </PaidOffWrapper>
      );
      break;

    case MANAGEABLE_LOAN_STATE:
      if (isPaymentPastDue) {
        currentAlert = (
          <OverdueWrapper>
            <CommonStyles>
              <FailedIcon style={iconStyle} />
              <span>
                Payment for {formatDate(nextPaymentDate, DateMasks.MonthDay)} is
                Overdue.
              </span>
            </CommonStyles>
          </OverdueWrapper>
        );
      }
      break;

    default:
      break;
  }

  return (
    <>
      {currentAlert && (
        <VehicleAlertWrapper>{currentAlert}</VehicleAlertWrapper>
      )}
    </>
  );
};

export default VehicleAlert;
